import { contact } from './contact';

export const privacy = {
  title: 'Privaatsuspoliitika',
  lastUpdated: '2026-07-09',
  sections: [
    {
      id: 'controller',
      title: 'Vastutav töötleja',
      body: [
        `${contact.legalName} on teie isikuandmete vastutav töötleja.`,
        `Aadress: ${contact.workshopAddressLines.join(', ')}, ${contact.postalCode} ${contact.city}, Eesti.`,
        `E-post: ${contact.email}`,
        `Telefon: ${contact.phoneDisplay}`,
      ],
    },
    {
      id: 'data',
      title: 'Milliseid andmeid kogume',
      body: [
        'Kontaktvormi kaudu: nimi, auto registrinumber, telefoninumber, e-posti aadress ja sõnum.',
        'Veebimajutaja võib salvestada tehnilisi serverilogisid (IP-aadress, brauseri tüüp, külastuse aeg) turvalisuse ja töökindluse tagamiseks.',
      ],
    },
    {
      id: 'purposes',
      title: 'Eesmärgid',
      body: [
        'Kasutame andmeid päringutele vastamiseks, teenuse osutamise korraldamiseks ja vajadusel teiega ühenduse võtmiseks seoses teie sõiduki remondi või hooldusega.',
      ],
    },
    {
      id: 'legal',
      title: 'Õiguslik alus',
      body: [
        'Andmete töötlemise õiguslik alus on teie nõusolek (vormi saatmine) ning lepingu ettevalmistamine või täitmine, kui päringust saab teenussuhe. Õigustatud huvi võib olla päringutele vastamine ja töökoja tegevuse korraldamine.',
      ],
    },
    {
      id: 'retention',
      title: 'Säilitamine',
      body: [
        'E-kirju ja päringuid säilitatakse tavapärase ärilise praktika kohaselt seni, kuni see on vajalik päringu lahendamiseks ja seaduslike kohustuste täitmiseks.',
        'Vormiteenuse pakkuja (nt Netlify Forms) võib säilitada esitatud andmeid vastavalt oma tingimustele.',
      ],
    },
    {
      id: 'recipients',
      title: 'Vastuvõtjad ja kolmandad osapooled',
      body: [
        'Veebimajutus (Netlify või samaväärne).',
        'Vormiteenuse pakkuja (Netlify Forms või Formspree/Getform, kui kasutatakse).',
        'Google Maps (kui avate kaardi lingi).',
        'Facebook (kui külastate meie lehte välislingi kaudu).',
        'Valikuline analüütika (Plausible), kui see on sisse lülitatud — ilma isikustatud reklaamiprofiilideta.',
      ],
    },
    {
      id: 'rights',
      title: 'Teie õigused',
      body: [
        'Teil on õigus taotleda juurdepääsu oma andmetele, nende parandamist või kustutamist, töötlemise piiramist ning esitada kaebus Andmekaitse Inspektsioonile (www.aki.ee).',
        `Selleks võtke meiega ühendust: ${contact.email} või ${contact.phoneDisplay}.`,
      ],
    },
    {
      id: 'cookies',
      title: 'Küpsised',
      body: [
        'Sait ei kasuta v1-s hädavajalikke jälgimisküpsiseid. Kui analüütika (nt Plausible) on hiljem sisse lülitatud, teavitatakse sellest siin.',
      ],
    },
  ],
};
